export class AwinProvider {
	protected id: string;

	constructor(id: string) {
		this.id = id;
	}

	trackTransaction(order: SalesOrder) {
		const total = (
			order.grand_total -
			order.shipping_amount -
			order.tax_amount +
			order.shipping_tax_amount
		).toFixed(2);

		// If the tracking script is set, use it directly
		if (typeof window.AWIN != 'undefined' && typeof window.AWIN.Tracking != 'undefined') {
			window.AWIN.Tracking.Sale = {
				amount: total,
				channel: 'aw',
				orderRef: order.ref,
				parts: 'VENTE:' + total,
				currency: order.currency!,
				voucher: order.coupon_code ?? '',
				test: '0',
			};

			window.AWIN.Tracking.run();
		}

		// Even if the tracking script is not set, the pixel should still be set
		const awPixel = new Image(0, 0);
		awPixel.src = `
			https://www.awin1.com/sread.img
			?tt=ns
			&tv=2
			&merchant=${this.id}
			&ch=aw
			&cr=${order.currency}
			&testmode=0
			&amount=${total}
			&parts=VENTE:${total}
			&ref=${order.ref}
			&vc=${order.coupon_code ?? ''}
		`;
	}
}

export default AwinProvider;
